// Action Types
export const FETCH_SEGMENTS_REQUEST = "FETCH_SEGMENTS_REQUEST";
export const FETCH_SEGMENTS_SUCCESS = "FETCH_SEGMENTS_SUCCESS";
export const FETCH_SEGMENTS_FAILURE = "FETCH_SEGMENTS_FAILURE";

// Action Creators
export const fetchSegmentsRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SEGMENTS_REQUEST,
      payload: params,
    });
  };
};
export const fetchSegmentsSuccess = (data) => ({
  type: FETCH_SEGMENTS_SUCCESS,
  payload: data,
});
export const fetchSegmentsFailure = (error) => ({
  type: FETCH_SEGMENTS_FAILURE,
  payload: error,
});
